import React, { useState, useEffect } from 'react';

// API'den çekmek yerine yerel veri kullanımı
const initData = {
    preHeading: "Farklıyız",
    preHeadingspan: "",
    heading: "Neden Socia?",
};

// Yerel özellik verileri
const featureData = [
    {
        id: 1,
        image: "/img/featured_image_1.png",
        title: "Zamanınıza Değer Katıyoruz",
        text: "Akıllı filreleme özelliği ile saniyeler içerisinde ilgi alanlarınıza uygun etkinliklere ulaşın ve sosyal medya hesaplarını takip etmeyi bırakın"
    },
    {
        id: 2,
        image: "/img/featured_image_2.png",
        title: "Etkinlikleri Kaçırma Korkusuna Son",
        text: "Favori organizatörlerin yeni etkinliklerini, katılmak istediğiniz ama unuttuğunuz etkinlikleri otomatik hatırlatırız."
    },
    {
        id: 3,
        image: "/img/featured_image_3.png",
        title: "Sosyal Hayatınızı Yeniden Tanımlayın",
        text: "Hiç denemediğiniz bir etkinlik türü (örneğin, bir kahve workshop’u veya resim sergisi) önererek rutininizi kırmanızı sağlar"
    },
];

const FeatureSection = () => {
    const [data, setData] = useState({});
    const [features, setFeatures] = useState([]);

    useEffect(() => {
        // API yerine yerel sabitten veri ayarlama
        setData(initData);
        setFeatures(featureData);
    }, []);

    return (
        <section id="features" className="section features-area style-two overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <span className="d-inline-block rounded-pill shadow-sm fw-5 px-4 py-2 mb-3">
                                <i className="far fa-lightbulb text-primary mr-1" />
                                <span className="text-primary">{data.preHeading}</span> {data.preHeadingspan}
                            </span>
                            <h2>{data.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{data.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{data.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {features.map((item, idx) => (
                        <div key={`fo_${idx}`} className="col-12 col-md-6 col-lg-4 res-margin">
                            {/* Image Box */}
                            <div className="image-box text-center icon-1 p-5">
                                {/* Featured Image */}
                                <div className="featured-img mb-3">
                                    <img className="avatar-sm" src={item.image} alt={item.title} />
                                </div>
                                {/* Icon Text */}
                                <div className="icon-text">
                                    <h3 className="mb-2" style={{ fontSize: '23px'}}>{item.title}</h3>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FeatureSection;